<template>
  <form
    autocomplete="off"
    @submit.prevent="$emit('submit')"
  >
    <TextInput
      v-model.trim="model.abbreviation"
      v-focus
      required
      :validation-error="errors?.abbreviation"
      label="Abbreviation"
    />

    <TextInput
      v-model.trim="model.fullName"
      required
      :validation-error="errors?.fullName"
      label="Full Name"
    />

    <button
      type="submit"
      class="hidden"
    />
  </form>
</template>

<script setup>
import { TextInput } from '@/components/form-inputs';

defineEmits(['submit']);

defineProps({
  errors: {
    type: Object,
    default: () => null,
  },
});
const model = defineModel();
</script>
